/* istanbul ignore file */
import React from 'react';
import { SingleBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import { usePurchaseOrderUrl, usePurchaseOrderId } from 'domain/finance/purchaseOrder/shared/usePurchaseOrderRouting';
import PurchaseOrderBreadcrumbs from 'domain/finance/purchaseOrder/shared/PurchaseOrderBreadcrumbs';

const SinglePurchaseOrderBreadcrumbs = ({ children }: { children?: React.ReactNode }) => {
  const { getSingleEntityUrl } = usePurchaseOrderUrl();
  const id = usePurchaseOrderId();

  return (
    <PurchaseOrderBreadcrumbs>
      <SingleBreadcrumbItem entity={id} link={getSingleEntityUrl(id)} />
      {children}
    </PurchaseOrderBreadcrumbs>
  );
};

export default SinglePurchaseOrderBreadcrumbs;
